export default __webpack_public_path__ + "static/media/checkIcon.eef3f89f.svg";